/* ######################################################################################################################## */
/* FUNCTION (TABS) ######################################################################################################## */
/* ######################################################################################################################## */
function tabs(speed, ease)
{
	jQuery('.js-tabs_tab', '.js-tabs').each(function()
	{
		var currURL = window.location.href;
			jQthis  = jQuery(this);
			idTabs  = '#' + jQthis.parents('.js-tabs').attr('id');
			idTab   = '#' + jQthis.attr('id');

		if(currURL.indexOf(idTab) >= 0)
		{
			jQuery('.js-tabs_nav li', idTabs).removeClass('open');
			jQuery('.js-tabs_nav li[data-tab="' + idTab + '"]', idTabs).addClass('open');

			jQuery('.js-tabs_tab', jQuery(idTabs)).hide();
			jQthis.stop(true, true).fadeIn(speed, ease);
		}
	});

	jQuery('.js-tabs_nav li').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		var jQthis   = jQuery(this);
			indexTab = parseInt(jQthis.index());
			idTabs   = jQthis.parents('.js-tabs_nav').attr('data-tabs');
			idTab    = jQthis.attr('data-tab');

		window.location.hash = idTab;

		if(!jQthis.hasClass('open'))
		{
			jQthis.siblings().removeClass('open'); // Remove class "open" from all the elements
			jQthis.addClass('open');               // Add class "open" to the correct element

			jQuery('.js-tabs_tab', jQuery(idTabs)).hide(); // Hide all the elements

			// Show the correct element
			jQuery('.js-tabs_tab', idTabs).eq(indexTab).stop(true, true).fadeIn(speed, ease, function()
			{
				// MOBILE: Scroll page to the correct element
				if(jQuery(window).width() < 768)
				{
					jQuery('html, body').animate(
					{
						scrollTop : jQuery(idTab).parents('.js-tabs_content').offset().top
					}, speed * 3, ease);
				}
			});
		}
	});
}
